import { t, useLocale } from "@/i18n/locale";
import { Message } from "@/i18n/Message";
// One-purpose popup route: acknowledge a session-continuation callback and
// close the tab.
import { useEffect } from "react";
import {
  continuationCallbackParams,
  postContinuationCallback,
} from "../../auth/sessionContinuationChannel";

export default function ContinuationCallback() {
  useLocale();
  const callback = continuationCallbackParams();

  useEffect(() => {
    if (!callback) return;
    postContinuationCallback(callback.channelId, callback.option);
    const timer = window.setTimeout(() => window.close(), 0);
    return () => window.clearTimeout(timer);
    // The callback params are immutable for this one-purpose popup route.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="empty-state">
      {callback
        ? t("Confirmation received. Return to the game tab.")
        : t("This continuation callback is invalid.")}
      {callback ? (
        <button className="settings-btn" onClick={() => window.close()}><Message message={"Close this tab"} /></button>
      ) : null}
    </div>
  );
}
